/*
 * @Author: Chao Yang
 * @Date: 2019-09-24 14:38:45
 * @LastEditor: Chao Yang
 * @LastEditTime : 2020-01-08 10:33:32
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { DefaultComponent } from './default/default.component';

@NgModule({
  declarations: [DefaultComponent, FooterComponent],
  imports: [CommonModule],
  exports: [FooterComponent]
})
export class FooterModule {}
